import { render, staticRenderFns } from "./CaseContainer.vue?vue&type=template&id=0f48d4b2&"
import script from "./CaseContainer.vue?vue&type=script&lang=js&"
export * from "./CaseContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports